var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSharedHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15 8.00039C2.15 9.68452 2.81902 11.2997 4.00987 12.4905C5.20073 13.6814 6.81588 14.3504 8.5 14.3504C10.1841 14.3504 11.7993 13.6814 12.9901 12.4905C14.181 11.2997 14.85 9.68452 14.85 8.00039C14.85 6.31627 14.181 4.70112 12.9901 3.51026C11.7993 2.31941 10.1841 1.65039 8.5 1.65039C6.81588 1.65039 5.20073 2.31941 4.00987 3.51026C2.81902 4.70112 2.15 6.31627 2.15 8.00039Z",
    stroke: "#525D71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65 6.3998C7.65 5.93036 8.03056 5.5498 8.5 5.5498C8.96944 5.5498 9.35 5.93036 9.35 6.3998C9.35 6.68297 9.21228 6.93393 8.99688 7.0896C8.75927 7.26132 8.46204 7.49391 8.22144 7.78587C7.9779 8.0814 7.75 8.48975 7.75 8.9998V9.1998C7.75 9.61402 8.08579 9.9498 8.5 9.9498C8.91422 9.9498 9.25 9.61402 9.25 9.1998V8.9998C9.25 8.95757 9.26638 8.87651 9.37902 8.73981C9.49461 8.59955 9.66547 8.45712 9.87549 8.30535C10.4644 7.87977 10.85 7.1848 10.85 6.3998C10.85 5.10194 9.79787 4.0498 8.5 4.0498C7.20213 4.0498 6.15 5.10194 6.15 6.3998C6.15 6.81402 6.48579 7.1498 6.9 7.1498C7.31422 7.1498 7.65 6.81402 7.65 6.3998ZM8.5 11.9998C8.94183 11.9998 9.3 11.6416 9.3 11.1998C9.3 10.758 8.94183 10.3998 8.5 10.3998C8.05817 10.3998 7.7 10.758 7.7 11.1998C7.7 11.6416 8.05817 11.9998 8.5 11.9998Z",
    fill: "#525D71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharedHelpIcon);
export default __webpack_public_path__ + "static/media/ic-shared-help-icon.5fb114166530c5de6c6441245ed57298.svg";
export { ForwardRef as ReactComponent };